export const AMAZON_THIRD_TYPE = 'alexa';

export const GOOGLE_THIRD_TYPE = 'google_assistant';

export const AMAZON_LINK_RESULT_STATUS_MAP = [
    {
        title: 'Link failed',
        desc: 'You can control your EcoFlow device by voice.',
        status: 'fail',
        pic: '/static/img/google-link-result/combine_fail@2x.png',
    },
    {
        title: 'Linking…',
        desc: '',
        status: 'ing',
        pic: '/static/img/google-link-result/combine_ing@2x.png',
    },
    {
        title: 'Link successful',
        desc: 'You can control your EcoFlow device by voice.',
        status: 'success',
        pic: '/static/img/google-link-result/combine_success@2x.png',
    },
];

export const GOOGLE_LINK_RESULT_STATUS_MAP = [
    {
        title: 'Link failed',
        desc: 'By signing in，you are authorizing Google to control your devices.',
        status: 'fail',
        pic: '/static/img/google-link-result/combine_fail@2x.png',
    },
    {
        title: 'Linking…',
        desc: '',
        status: 'ing',
        pic: '/static/img/google-link-result/combine_ing@2x.png',
    },
    {
        title: 'Link successful',
        desc: 'By signing in，you are authorizing Google to control your devices.',
        status: 'success',
        pic: '/static/img/google-link-result/combine_success@2x.png',
    },
];

export const AMAZON_DEVICE_STATUS_MAP = [
    {
        title: 'Link EcoFlow account with Alexa account',
        desc: 'You can control your EcoFlow device by voice.',
        bg_pic: '/static/img/amazon-link-account/link_Background@2x.png',
        status_pic: '/static/img/google-link-result/combine_ing@2x.png',
    },
    {
        title: 'Link successful',
        desc: 'You can control your EcoFlow device by voice.',
        status: 'success',
        bg_pic: '/static/img/amazon-link-account/link_Background@2x.png',
        status_pic: '/static/img/google-link-result/combine_success@2x.png',
    },
];

export const GOOGLE_DEVICE_STATUS_MAP = [
    {
        title: 'Link EcoFlow account with Google account',
        desc: 'By signing in，you are authorizing Google to control your devices.',
        status: 'fail',
        bg_pic: '/static/img/google-link-account/link_Background@2x.png',
        status_pic: '/static/img/google-link-result/combine_ing@2x.png',
    },
    {
        title: 'Link successful',
        desc: 'By signing in，you are authorizing Google to control your devices.',
        status: 'success',
        bg_pic: '/static/img/google-link-account/link_Background@2x.png',
        status_pic: '/static/img/google-link-result/combine_success@2x.png',
    },
];
